import React from 'react'
import { ExitTypo, Header, LogoTypo, Span, StepsTypo, StepsValue } from '../../CourseCreationFlow/styles'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import ProgressBar from '../ProgressBar/progressbar'
import { stepsHeaderSx } from './styles'

export const StepsHeader = ({ handleExit, steps }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const stepNames = [
    "Basics",
    "Intended Learner",
    "Curriculum",
    "Details",
    "Class Schedule",
    "Course Listing Preview",
  ];
  return (
    <div>
      <Header alignItems={"center"}>
        <Grid
          container
          sx={stepsHeaderSx.gridContainer}
        >
          <Grid lg={2} md={2} sm={3} xs={3}>
            <Box
              sx={stepsHeaderSx.logoBox}
            >
              <Span>
                <LogoTypo color={"primary"} variant="h4" onClick={handleExit}>
                  Vulcan
                </LogoTypo>
              </Span>
            </Box>
          </Grid>
          <Grid
            sx={stepsHeaderSx.stepsGrid}
            lg={7}
            md={6}
            sm={6}
            xs={6}
          >
            <StepsTypo variant="h6">
              {isSmallScreen ? (
                <>
                  Step {steps} of 6 <br />
                  <StepsValue sx={{ color: (theme) => theme.palette.primary.main }}>
                    {stepNames[steps - 1]}
                  </StepsValue>
                </>
              ) : (
                <>
                  Step {steps} of 6:{" "}
                  <StepsValue
                    sx={{ color: (theme) => theme.palette.primary.main }}
                    ml={2}
                    style={{ paddingLeft: "10px" }}
                  >
                    {stepNames[steps - 1]}
                  </StepsValue>
                </>
              )}
            </StepsTypo>
          </Grid>
          <Grid
            lg={2}
            md={2}
            sm={2}
            xs={2}
            sx={stepsHeaderSx.exitGrid}
          >
            <Span>
              <ExitTypo variant="h6" color="primary" onClick={handleExit}>
                Exit
              </ExitTypo>
            </Span>
          </Grid>
        </Grid>
        <ProgressBar />
      </Header>
    </div>
  )
}
